<script lang="ts">
	//UI
	import { HubProfileTextInput, DefaultButton } from "@hitit/new_ui";
	import Message from "./Message.svelte";
	import CancelButton from "./CancelButton.svelte";
	import ProfileInputFrame from "./ProfileInputFrame.svelte";
	import ProfileViewer from "./ProfileViewer.svelte";
	//Utils
	import { t, api } from "../../../stores";

	export let userId: string | undefined = undefined;
	//variables
	let editmode = false;

	let password = "";
	let newPassword = "";
	let confirmPassword = "";
	//errors
	let newPasswordError = "";
	let passwordError = "";
	let confirmPasswordError = "";

	let submitting = false;

	function checkInputs() {
		passwordError =
			password.length === 0 ? "hub.profile.enter_current_password" : "";

		newPasswordError = !/^[a-zA-Z\d@$!$*#?&]*$/.test(newPassword)
			? $t("hub.profile.password_error_invalid")
			: newPassword.length < 8
			? $t("hub.profile.password_error_8")
			: "";

		confirmPasswordError =
			newPassword !== confirmPassword
				? $t("hub.profile.password_confirm_error")
				: "";

		if (passwordError || confirmPasswordError || passwordError) {
			return false;
		} else {
			return true;
		}
	}

	async function submitHandler() {
		try {
			//password checked
			if (!checkInputs()) {
				return;
			}

			submitting = true;

			const response = await $api.updateUserPassword(
				userId as string,
				password,
				newPassword
			);

			if (response.data.status !== "OK") {
				passwordError = "hub.profile.password_does_not_match";
				return;
			}

			resetAll();
		} catch {
			passwordError = "hub.profile.please_try_again";
		} finally {
			submitting = false;
		}
	}

	function resetAll() {
		password = "";
		newPassword = "";
		confirmPassword = "";
		passwordError = "";
		newPasswordError = "";
		confirmPasswordError = "";
		newPassword = "";
		confirmPassword = "";
		editmode = false;
	}

	$: saveButtonDisabled =
		passwordError ||
		confirmPasswordError ||
		passwordError ||
		password.length === 0 ||
		confirmPassword.length === 0 ||
		newPassword.length === 0 ||
		submitting
			? true
			: false;

	$: backgroundColor = saveButtonDisabled ? "#a5c1f9" : "#6b93f3";

</script>

<form
	class:edit={editmode}
	on:submit|preventDefault={submitHandler}
	disabled={submitting}>
	{#if !editmode}
		<div class="frame">
			<ProfileViewer
				name={$t('hub.profile.password')}
				value={'*********'}
				on:click={() => (editmode = true)} />
		</div>
	{:else}
		<div class="container">
			<div class="messageFrame">
				<ProfileInputFrame name={$t('hub.profile.password')}>
					<HubProfileTextInput
						on:input={() => (passwordError = '')}
						error={passwordError !== ''}
						disabled={submitting}
						password
						bind:value={password} />
				</ProfileInputFrame>
				<Message error messageTrnaslation={passwordError} />
			</div>
			<div class="messageFrame">
				<ProfileInputFrame name={$t('hub.profile.new_password')}>
					<HubProfileTextInput
						on:input={() => (newPasswordError = '')}
						placeholder={$t('hub.profile.over_8')}
						error={newPasswordError !== ''}
						disabled={submitting}
						password
						bind:value={newPassword} />
				</ProfileInputFrame>
				<Message error messageTrnaslation={newPasswordError} />
			</div>
			<div class="messageFrame">
				<ProfileInputFrame name={$t('hub.profile.new_password_confirm')}>
					<HubProfileTextInput
						on:input={() => (confirmPasswordError = '')}
						placeholder={$t('hub.profile.over_8')}
						error={confirmPasswordError !== ''}
						disabled={submitting}
						password
						bind:value={confirmPassword} />
				</ProfileInputFrame>
				<Message error messageTrnaslation={confirmPasswordError} />
			</div>
		</div>
		<div class="button-container">
			<div class="button-box done" class:confirmPasswordError>
				<DefaultButton
					nonePadding
					fitmode
					background={backgroundColor}
					disabled={submitting}
					isLoading={submitting}
					on:click={submitHandler}>
					<span class="white">{$t('global.save')}</span>
				</DefaultButton>
			</div>
		</div>
		<div class="cancelbox">
			<CancelButton on:click={resetAll} />
		</div>
	{/if}
</form>

<style lang="scss">
	@import "../../../variables.scss";

	div {
		box-sizing: border-box;
	}

	form {
		display: flex;
		flex-direction: column;
		position: relative;
		padding: 0 20px;
		gap: 10px;

		.frame {
			flex-grow: 1;
		}

		&.edit {
			background-color: #e6e7ed;
			padding: 20px 20px;
		}
		.messageFrame {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			gap: 6px;
		}

		.container {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			gap: 20px;
		}

		.button-box {
			flex-grow: 1;
			height: 32px;

			&.done {
				.white {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: 100%;
					font-size: 1rem;
					color: white;
				}
			}
		}
		.cancelbox {
			position: absolute;
			top: 10px;
			right: 10px;
		}
	}

	@include DesktopSize {
		form {
			flex-direction: row;
			position: relative;
			padding: 0 40px;
			gap: 20px;

			.cancelbox {
				position: absolute;
				top: 20px;
				right: 20px;
			}

			&.edit {
				background-color: #e6e7ed;
				padding: 20px 40px;
			}

			.messageFrame {
				gap: 10px;
			}

			.container {
				flex-direction: column;
				gap: 20px;
			}

			.button-container {
				display: flex;
				.button-box {
					min-width: 150px;
					flex-basis: 150px;
					flex-grow: 0;
					box-sizing: border-box;
					height: 40px;

					&.confirmPasswordError {
						margin-bottom: 26px;
					}
	
					&.done {
						margin-top: auto;
						.white {
							font-size: 1.25rem;
						}
					}
				}
			}
		}
	}

</style>
